import {gql} from '@apollo/client/core';
import {GroupVoucherFragment} from './group-voucher.fragment';
import {UserCartFragment} from './user-cart.fragment';
import {CustomerProfileFragment} from '@core/fragments/customer-profile.fragment';

export const SessionResponseFragment = gql`
  fragment SessionResponseFragment on SessionResponse {
    id
    userSession {
      sessionId
      gclid
      algoliaId
      firstUtm
      latestUtm
      superpayId
      cartId
      cookieConsent
      createdAt
      updatedAt
      testCases
    }
    cart {
      ...userCart
    }
    groupVoucher {
      ...groupVoucher
    }
    customerProfile {
      ...customerProfile
    }
  }
  ${UserCartFragment}
  ${GroupVoucherFragment}
  ${CustomerProfileFragment}
`;
